module.exports = __webpack_public_path__ + "img/alfie-m2.d61fdee6.png";